// Core
import { Middleware } from '@reduxjs/toolkit'

// Utils
import { sendGTMEvent } from 'utils/gtm/sendGTMEvent'

// Constants
import { SUBSCRIPTION_ACTIONS } from 'state-manager/constants'

// Redux
import { IRootState } from 'state-manager/reducers/root-reducer'

export const gtmMiddleware: Middleware<object, IRootState> = (store) => (next) => (action) => {
  const result = next(action)

  if (action.type === SUBSCRIPTION_ACTIONS.SUBSCRIBED_SUCCESS.SYSTEM) {
    const state = store.getState()
    const currentSubscription = state.subscriptions.data
    const coupon = state.coupon?.name ? state.coupon.name : null

    const subscriptionEventData = (
      eventType: 'trial' | 'purchase',
      currentSubscription: typeof state.subscriptions.data,
      coupon: string | null
    ) => ({
      event: eventType,
      currency: currentSubscription.currency, //3-digit ISO value of the currency e.g. GBP or USD
      package: currentSubscription.plan?.monthlyMediaSpend, // plan value (i.e. 100,000 or 200,000 or 1,000,000)
      plan: currentSubscription.plan?.period, // monthly or yearly from the package selection
      value: currentSubscription.plan?.price,  // plan amount i.e. 79.00 or 190 for the 100K plan
      ...(coupon ? { coupon } : {}) // coupon is used only if one is supplied otherwise it is not sent.
    })

    if (currentSubscription?.isOnTrial) {
      const eventData = subscriptionEventData('trial', currentSubscription, coupon)
      sendGTMEvent(eventData)
    }

    if (currentSubscription?.isSubscriptionActive) {
      const eventData = subscriptionEventData('purchase', currentSubscription, coupon)
      sendGTMEvent(eventData)
    }
  }

  return result
}
